<template>
  <component
    :is="cardComponent"
    v-bind="$props"
    :competence-areas="competenceAreas"
    :is-lawyer="isLawyer"
    :link="link"
    :schedule="schedule"
    :selected-competences="selectedCompetences"
  />
</template>

<script>
import BaseCounselorCard from './BaseCounselorCard.vue';
import CounselorCardRoundImage from './variants/CounselorCardRoundImage.vue';
import CounselorCardTextOnImage from './variants/CounselorCardTextOnImage.vue';

export default {

  components: {
    CounselorCardRoundImage,
    CounselorCardTextOnImage,
  },

  computed: {
    cardComponent() {
      return this.isTherapist
        ? 'counselor-card-round-image'
        : 'counselor-card-text-on-image';
    },
  },

  extends: BaseCounselorCard,
  name: 'CounselorCard',

  props: {
    cityLabel: {
      default: '',
      type: String,
    },
    counselor: {
      required: true,
      type: Object,
    },
    isLawyer: {
      default: false,
      type: Boolean,
    },
    isTherapist: {
      default: false,
      type: Boolean,
    },
    role: {
      default: '',
      type: String,
    },
    selectedCompetences: {
      default: '',
      type: String,
    },
    showCompetenceAreas: {
      default: false,
      type: Boolean,
    },
    showPhoneNumber: {
      default: false,
      type: Boolean,
    },
  },
};
</script>
